import { Box, Flex, Skeleton } from '@chakra-ui/react';
import React from 'react';

import { BorrowerHeader } from 'borrower/domains/page/ui/BorrowerHeader';
import { BorrowerSideBar } from 'borrower/domains/page/ui/SideBar';
import 'borrower/borrower.scss';
import CreditFacilityProvider from 'packages/credit-facility/hooks/CreditFacilityProvider';
import CreditFacilityMissingFallback from 'packages/credit-facility/ui/CreditFacilityMissingFallback';
import { useUserAuthOrThrow } from '~/contexts/UserAuthProvider';

type Props = { children: React.ReactNode };
export const BorrowerTemplate = ({ children }: Props) => {
  const { user } = useUserAuthOrThrow();
  return (
    <>
      <BorrowerHeader />
      <Flex minH="95vh" grow={1} pt="84px">
        <CreditFacilityProvider
          organizationId={user.organizationId}
          renderLoading={<Skeleton />}
          fallbackComponent={<CreditFacilityMissingFallback />}
        >
          <BorrowerSideBar />
          <Box padding="40px" width="100%" overflowX="auto">
            {children}
          </Box>
        </CreditFacilityProvider>
      </Flex>
    </>
  );
};
